export default "https://assets-v2.scaler.com/packs/files/post-purchase-heading.09b3d1.webp";